import React, { FunctionComponent } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { useTranslation } from 'react-i18next';
import {
  SingleTabEditDialog,
  SingleTabEditDialogProps
} from 'record-it-components/modal/SingleTabEditDialog/SingleTabEditDialog';
import { EditTimeTrackingConfigurationForm } from '../EditTimeTrackingConfigurationForm/EditTimeTrackingConfigurationForm';
import { TimeTrackingConfiguration } from '../../../classes/entities/TimeTrackingConfiguration/timeTrackingConfigurationTypes';
import { EntityName } from 'record-it-time-common/EntityName';
import { useModifyEntityCallback } from '../../../hooks/entity/useModifyEntityCallback';

export type EditTimeTrackingConfigurationDialogProps = Omit<
  SingleTabEditDialogProps,
  'tabTitle' | 'children'
> & {
  timeTrackingConfiguration: TimeTrackingConfiguration;
};

export const EditTimeTrackingConfigurationDialog: FunctionComponent<EditTimeTrackingConfigurationDialogProps> =
  React.memo((props) => {
    const { timeTrackingConfiguration, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });
    const { t } = useTranslation();

    const handlePropertyChanged = useModifyEntityCallback(
      EntityName.TimeTrackingConfiguration
    );

    return (
      <SingleTabEditDialog
        {...remainingProps}
        tabTitle={t(
          'components.timeTrackingConfiguration.EditTimeTrackingConfigurationDialog.title'
        )}
      >
        <EditTimeTrackingConfigurationForm
          timeTrackingConfiguration={timeTrackingConfiguration}
          onPropertyChanged={handlePropertyChanged}
          data-testid="EditTimeTrackingConfigurationDialog.Form"
        ></EditTimeTrackingConfigurationForm>
      </SingleTabEditDialog>
    );
  });
